
<div class=" d-none d-sm-block">
	<!------------------------------------------TITLE----------------------------------------------->
	<div class="title-box uk-border-rounded p-1 d-none d-sm-block">
		<div class="head-card p-1 inner-title-box">
		  <h1 class="title-text text-center font-weight-bold">
			MULTI BRAND OIL CHILLER
		  </h1>
		  <div class="text-right">
			<h5 class="text-light">
				<span class="sub-menu" routerLink="/home-page">HOME </span>&nbsp;
				<span class="sub-menu" routerLink="/contact-us"> CONTACT</span>&nbsp;
				<span class="sub-menu" routerLink="/ourproducts"> PRODUCTS</span>&nbsp;
				<span class="sub-menu" routerLink="/verticals"> SERVICES</span>&nbsp;
			</h5>
		  </div>
		</div>
	   </div>

	  <!--------------------------------------------------TITLE END-------------------------------------------->
	<!------------------------------------------------------------CAROSUEL----------------------------------------------------->
	<div class="content-container">   
		<a class="mail-call" href="tel:8489359948">
            <span class="fa fa-phone" aria-hidden="true"></span>
        </a>  
		<a class="mail-call1" href="mailto:rvproduction2017@gmail.com"><span class="fa fa-envelope"></span>
		</a>   
		<a class="mail-call2" href="https://wa.me/8489359948" target="_blank">
			<span class="fa fa-whatsapp"></span>
		</a>
        <img src="../../assets/img/multi-brand/multibrand5.jpg" alt="">
        <br>
        <ul>
            <li>Air-Cooled Oil Chillers – Uses air to dissipate heat from the system and cool the oil.
            Water-Cooled Oil Chillers – Utilizes water as the medium to absorb and carry away heat from the oil.
            &nbsp; Industrial Oil Chillers – Designed for heavy-duty operations with larger cooling capacities
                 for industrial applications like CNC machines, hydraulic systems, and lubrication systems.
             Portable Oil Chillers – Compact and mobile units that are typically used for temporary or smaller-scale cooling requirements</li>
        </ul>



        <p>
            An oil chiller is a cooling system specifically designed to cool the oil used in machinery, industrial equipment, or hydraulic systems.
             By maintaining an optimal temperature, oil chillers prevent overheating, enhance the efficiency of the equipment, and extend its operational life. They are crucial for
             industries such as manufacturing, automotive, and energy, where oil temperature regulation is key to performance and safety.
        </p>
        <p>
            Noisy Operation – Unusual noises such as rattling or humming may indicate a mechanical problem, worn components, or a lack of lubrication.
            Blocked Oil Flow – Obstructions in the pipes or filters may cause poor oil circulation and reduced cooling efficiency.
            Temperature Fluctuations – Inconsistent oil temperatures, either too high or too low, can be a sign of malfunctioning thermostats, sensor issues, or improper maintenance.
        </p>
    </div>
</div>




<!--------------------------------------- MOBILE VIEW ------------------------------------------------->

<div class=" d-block d-sm-none">
	<a class="mail-call" href="tel:8489359948">
		<span class="fa fa-phone" aria-hidden="true"></span>
	</a>  
	<a class="mail-call1" href="mailto:rvproduction2017@gmail.com"><span class="fa fa-envelope"></span>
	</a>   
	<a class="mail-call2" href="https://wa.me/8489359948" target="_blank">
		<span class="fa fa-whatsapp"></span>
	</a>
    <img src="../../assets/img/multi-brand/multibrand5.jpg" alt="">
    <br>
    <ul>
        <li>Air-Cooled Oil Chillers – Uses air to dissipate heat from the system and cool the oil.
        Water-Cooled Oil Chillers – Utilizes water as the medium to absorb and carry away heat from the oil.
        &nbsp; Industrial Oil Chillers – Designed for heavy-duty operations with larger cooling capacities
             for industrial applications like CNC machines, hydraulic systems, and lubrication systems.
         Portable Oil Chillers – Compact and mobile units that are typically used for temporary or smaller-scale cooling requirements</li>
    </ul>



    <p>
        An oil chiller is a cooling system specifically designed to cool the oil used in machinery, industrial equipment, or hydraulic systems.
         By maintaining an optimal temperature, oil chillers prevent overheating, enhance the efficiency of the equipment, and extend its operational life. They are crucial for
         industries such as manufacturing, automotive, and energy, where oil temperature regulation is key to performance and safety.
    </p>
    <p>
        Noisy Operation – Unusual noises such as rattling or humming may indicate a mechanical problem, worn components, or a lack of lubrication.
        Blocked Oil Flow – Obstructions in the pipes or filters may cause poor oil circulation and reduced cooling efficiency.
        Temperature Fluctuations – Inconsistent oil temperatures, either too high or too low, can be a sign of malfunctioning thermostats, sensor issues, or improper maintenance.
    </p>
    </div>
